import { SolvReduxState } from '../reducers';
import { EN_US, ES_US, SupportedLocale } from '../core/util/localizedStr';
import { NewBookingState } from '../reducers/newBooking';

const getNewBooking = (state: SolvReduxState): NewBookingState => state?.newBooking ?? null;

export const getNewBookingLocale = (state: SolvReduxState): SupportedLocale => {
  const newBooking = getNewBooking(state);

  if (newBooking?.locale) {
    return newBooking.locale;
  }

  return EN_US;
};
